var BraintreeTokenizedCardTypeEnum;
(function (BraintreeTokenizedCardTypeEnum) {
    BraintreeTokenizedCardTypeEnum["AMEX"] = "American Express";
    BraintreeTokenizedCardTypeEnum["DISCOVER"] = "Discover";
    BraintreeTokenizedCardTypeEnum["MASTERCARD"] = "MasterCard";
    BraintreeTokenizedCardTypeEnum["VISA"] = "Visa";
})(BraintreeTokenizedCardTypeEnum || (BraintreeTokenizedCardTypeEnum = {}));
export default BraintreeTokenizedCardTypeEnum;
//# sourceMappingURL=BraintreeTokenizedCardTypeEnum.js.map